/* Copyright (c) 2025 MOCA Systems, Inc.  All rights reserved. */
import { GraphicsGeometry } from 'pixi.js-legacy';
import { FancyGraphics } from '@appCanvasCommon/graphics/FancyGraphics';
/**
 * LightboxMask is a thin wrapper around FancyGraphics that provides some helper methods for drawing the lightbox mask data
 * This can be expanded later to include other mask shapes other than rectangles.
 */
export class LightboxMask extends FancyGraphics {
	/**
	 * Constructor for the lightbox mask. Makes it exist or something
	 * @param geometry Prefilled geometric data to use for this graphics object
	 */
	constructor(geometry?: GraphicsGeometry) {
		super(geometry);
	}
	/**
	 * Helper method to draw an inverted mask, which creates a cutout effect
	 * @param x The x position of the cutout rectangle
	 * @param y The y position of the cutout rectangle
	 * @param width The width of the cutout rectangle
	 * @param height The height of the cutout rectangle
	 * @param screenWidth The full screen width
	 * @param screenHeight The full screen height
	 */
	public drawMask(
		x: number,
		y: number,
		width: number,
		height: number,
		screenWidth: number,
		screenHeight: number
	): void {
		this.clear();
		// Using a hardcoded value here because the color does nothing when drawing a mask
		this.beginFill(0x000000);

		this.drawRect(0, 0, screenWidth, screenHeight);
		this.beginHole();
		this.drawRect(x, y, width, height);
		this.endHole();

		this.endFill();
	}
}
